<mat-dialog-content
    style="display: flex; flex-direction: column; max-height: calc(100% - 90px);height: calc(100% - 90px);">

    <span mat-dialog-title>Checklisten Eintrag bearbeiten</span>

    <div *ngIf="data.toDo.done" style="margin-bottom: 20px; border: 2px solid green;">
        <div>
            Erledigt von {{data.toDo.doneByName}} am {{data.toDo.doneAt | date}}
        </div>
        <div *ngIf="data.toDo.type === 'input'">
            Eingabe: {{data.toDo.inputValue}}
        </div>
        <div>
            <button mat-raised-button mat-button (click)="resetToDo()" tabindex="-1"><span>Erledigung zurücksetzen</span></button>
        </div>
    </div>

    <mat-form-field>
        <mat-label>Art des ToDos</mat-label>
        <mat-select [(ngModel)]="data.toDo.type" placeholder="Art des ToDos">
            <mat-option value="manuell">Erledigung bestätigen</mat-option>
            <mat-option value="input">Eingabefeld</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Zeitpunkt</mat-label>
        <mat-select [(ngModel)]="data.toDo.time" placeholder="Zeitpunkt">
            <mat-option value="before">Vor Umstellung</mat-option>
            <mat-option value="while">Während Umstellung</mat-option>
            <mat-option value="after">Nach Umstellung</mat-option>
        </mat-select>
    </mat-form-field>

    <div style="display: flex;">
        <mat-form-field style="flex-grow: 1;">
            <mat-label>Titel</mat-label>
            <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
                placeholder="Titel" [(ngModel)]="data.toDo.title">
        </mat-form-field>
    </div>

    <div style="display: flex;">
        <mat-form-field style="flex-grow: 1;">
            <mat-label>Kategorie</mat-label>
            <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
                placeholder="Kategorie" [(ngModel)]="data.toDo.category">
        </mat-form-field>
    </div>

    <div style="display: flex;">
        <mat-form-field style="flex-grow: 1;">
            <mat-label>Info / Beschreibung</mat-label>
            <textarea matInput [(ngModel)]="data.toDo.info" placeholder="Info" cdkTextareaAutosize
                #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10" cdkAutosizeMaxRows="50"></textarea>
        </mat-form-field>
    </div>


    <div style="display: flex;">
        <mat-form-field style="flex-grow: 1;">
            <mat-label>Link Anwenderportal</mat-label>
            <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
                placeholder="Link Anwenderportal" [(ngModel)]="data.toDo.infoLink">
        </mat-form-field>
    </div>


</mat-dialog-content>
<mat-dialog-actions>
    <button color="primary" mat-raised-button mat-button (click)="save()" tabindex="-1"><span>Änderungen
            speichern</span></button>
    <button mat-raised-button mat-button mat-dialog-close tabindex="-1"><span>Abbrechen</span></button>
</mat-dialog-actions>